<template>

    <div v-if="editable" class="breadcrumb-item" v-click-outside="stopEditing">
        <div class="divider">/</div>
        <span ref="title" @click="editing = true" @keyup="changedTitle" @keydown.enter.prevent="savedTitle" contenteditable>{{ editableTitle }}</span>
        <v-button v-if="editing" class="ml-10" size="xs" btn-style="white" @click.native="savedTitle">Save</v-button>
    </div>

    <div v-else class="breadcrumb-item">
        <div class="divider">/</div>
        <span v-if="title">{{ title }}</span>
        <slot v-else></slot>
    </div>

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .breadcrumb-item {
        align-items: center;
        color: $color-text;
        display: flex;
        margin: 0;
        padding: 0;
        &::before {
            display: none !important;
        }
        &:first-child {
            .divider {
                display: none;
            }
        }
        .divider {
            margin: 0 5px;
            opacity: 0.5;
            padding: 0;
        }
    }

</style>

<script>

import ClickOutside from 'vue-click-outside';

export default {

    directives: {
        ClickOutside,
    },

    props: {
        editable: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
        },
    },

    data() {
        return {
            editing: false,
            editableTitle: this.title,
        }
    },

    methods: {

        stopEditing() {
            this.editing = false;
            if (this.$refs.title.innerText.length === 0) {
                this.$refs.title.innerText = this.title;
            }
        },

        changedTitle() {
            this.$emit('changed', this.$refs.title.innerText);
        },

        savedTitle() {
            this.editing = false;
            this.$emit('saved', this.$refs.title.innerText);
        },

    },

}

</script>
